import { useTranslation } from "react-i18next";
import { context } from "../utils";

const ImplantCard = ({ implant, onClick }) => {
    const { t } = useTranslation();

    const ImplantDetailUrl = `/${context.current_language}/${t('dental-implants')}/${implant.brand_slug}/${implant.slug}`;


    return <div className={"card implant-card"} onClick={onClick}>
        {implant.main_image_url ? <div className="card-img-top">
            <img src={implant.main_image_url} alt="Main implant" />
        </div>
            : <div className="card-img-top no-image"> <div>{t("No image available")}</div></div>
        }

        <div className="card-body">
            <div>
                <h5 className="card-title">{implant.name}</h5>
                <p className="card-text">
                    {implant.brand_name}
                </p>
            </div>

            <a href={ImplantDetailUrl} className="stretched-link"></a>
        </div>
    </div>;
};

export const ImplantCardInline = ({ implant, onClick }) => {
    return <div className="card implant-card no-animation" onClick={onClick}>
        {implant.main_image_url ? <div className="card-img-left">
            <img src={implant.main_image_url} alt="Main implant" />
        </div>
            : <i className="fas fa-images card-img-left" style={{ fontSize: "200%" }}></i>
        }
        <div className="card-body">
            <div>
                <p className="card-text">
                    {implant.brand_name} {implant.name}
                </p>
            </div>
        </div>
    </div>;
};


export const ImplantListGroupItem = ({ implant, onClick }) => {
    const imgUrl = implant.main_image_url;
    return <button
        onClick={onClick}
        className="list-group-item block-with-inline-img list-group-item-action">
        <div className="img-container">
            {imgUrl ?
                <img src={imgUrl} className="img-responsive" />
                : <i className="fas fa-images card-img-left" style={{ fontSize: "200%" }}></i>

            }
        </div>

        <div>{implant.brand_name} {implant.name}</div>
    </button>;
};

export default ImplantCard;